import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const Delete = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.44 5.43H15.78V3.85C15.78 2.83 14.95 2 13.93 2H10.07C9.05 2 8.22 2.83 8.22 3.85V5.44H2.56C2.25 5.44 2 5.69 2 6C2 6.31 2.25 6.56 2.56 6.56H4.41L5.56 20.31C5.63 21.27 6.43 22.01 7.39 22.01H16.61C17.57 22.01 18.37 21.27 18.44 20.31L19.59 6.56H21.44C21.75 6.56 22 6.31 22 6C22 5.69 21.75 5.44 21.44 5.44V5.43ZM9.34 3.85C9.34 3.45 9.67 3.12 10.07 3.12H13.93C14.33 3.12 14.66 3.45 14.66 3.85V5.44H9.34V3.85ZM17.33 20.21C17.3 20.59 16.99 20.88 16.61 20.88H7.39C7.02 20.88 6.7 20.59 6.67 20.21L5.53 6.55H18.48L17.34 20.21H17.33ZM10.07 9.93994C9.76001 9.93994 9.51001 10.1899 9.51001 10.4999V16.9399C9.51001 17.2499 9.76001 17.4999 10.07 17.4999C10.38 17.4999 10.63 17.2499 10.63 16.9399V10.4999C10.63 10.1899 10.38 9.93994 10.07 9.93994ZM13.37 10.4999C13.37 10.1899 13.62 9.93994 13.93 9.93994C14.24 9.93994 14.49 10.1899 14.49 10.4999V16.9399C14.49 17.2499 14.24 17.4999 13.93 17.4999C13.62 17.4999 13.37 17.2499 13.37 16.9399V10.4999Z"
    />
  </svg>
)

export default withDefaultStyles(Delete)
